import React, { Component } from "react";
import { Link } from "react-router-dom";

/**
 * Billing detail view stub — replaces Lorem Ipsum demo content.
 * Live billing history uses /billing-details and related API-backed pages.
 */
class BillingDeatilsView extends Component {
  render() {
    return (
      <div>
        <div className="main padding-top-md">
          <div className="top-bottom-spacing">
            <div className="row">
              <div className="col-sm-10 col-md-10 col-lg-8 col-xl-8 auto-margin text-center">
                <div className="subcsription-card">
                  <div className="subcsription-head">
                    <h4 className="mt-0">Billing details</h4>
                    <p className="subscription-desc">
                      View your subscription and payment history from Account.
                    </p>
                  </div>
                  <div className="subcsription-details mt-4">
                    <Link to="/billing-details" className="btn btn-danger">
                      Billing history
                    </Link>
                    <Link to="/account" className="btn btn-grey ml-2">
                      Account
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default BillingDeatilsView;
